module.exports = __webpack_public_path__ + "img/0xbf5140a22578168fd562dccf235e5d43a02ce9b1.526d493f.png";